<!-- 敏感词拦截 -->
<template>
  <div>
    <el-row type="flex" justify="center" style="margin-top:20px;">
      <el-col :span="24">
        <el-card class="box-card" style="height: 750px">
          <el-form :model="dataList" :rules="rules" ref="registerRef">
            <p style="padding: 0px 20px 20px 0px">新增敏感词</p>
            <div class="text item">
              <p style="padding: 0px 20px 5px 0px">用户发送的消息包含以下内容时将进行拦截</p>
              <div class="boxinput">
                <div class="input-le">
                  <el-form-item label-width="0px" prop="Wordname">
                    <el-input
                        style="width: 950px"
                        placeholder="请输入您需要添加的敏感词"
                        v-model="dataList.Wordname">
                    </el-input>
                    <div style="padding-left: 15px">输入敏感词，输入多个敏感词请用空格键隔开。</div>
                  </el-form-item>

                </div>

              </div>
            </div>
            <p style="padding-top: 10px;padding-bottom: 10px">拦截范围</p>
            <div class="text item">
              <div class="boxinput1">
                <div class="input-le1">
                  <el-input
                      disabled
                      placeholder="拦截范围公示"
                      v-model="publicity">
                  </el-input>
                </div>

                <div class="checkbox">
                  <div class="checkboxi">
                    <div class="box1">
                      <p>
                        <el-checkbox v-model="checked1" disabled>人才端与企业端的沟通聊天</el-checkbox>
                      </p>
                      <p>
                        <el-checkbox v-model="checked2" disabled>人才端的在线简历</el-checkbox>
                      </p>
                    </div>
                    <div class="box2">
                      <p>
                        <el-checkbox v-model="checked3" disabled>企业信息：企业简介</el-checkbox>
                      </p>
                      <p>
                        <el-checkbox v-model="checked4" disabled>企业端职位发布</el-checkbox>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="boxbutton">
                  <el-button type="primary" @click="SensitivAdd('registerRef')" class="btnAdd">新增</el-button>
                  <el-button type="info" @click="reset" class="btnAdd">重置</el-button>
                </div>
              </div>
            </div>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Head from '@/components/header/head.vue';

export default {
  name: "company",
  components: {
    Head,
  },
  data() {
    return {
      dataList: {
        Wordname: '',
      },
      rules: {
        Wordname: [
          {required: true, message: '请输入您需要添加的敏感词', trigger: 'blur'}
        ]
      },
      publicity: "",
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    // 添加敏感词
    SensitivAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axiosPost(`/sensitiveWord/add`, {
            sensitiveWord: this.dataList.Wordname,
          }).then((res) => {
            if (res.code == 200) {
              this.reset()
              this.$message.success(res.message)
            }
          })
        } else {
          // this.$message.error('请输入您需要添加的敏感词')
        }
      })
    },
    //  重置
    reset() {
      let _this = this;
      _this.dataList.Wordname = ""
      _this.$refs["registerRef"].clearValidate();
    },
  }
}
</script>

<style lang="less" scoped>
.text {
  .boxinput {
    width: 1000px;
    height: 150px;
    background-color: #EAF3FF;

    .input-le {
      width: 1000px;
      padding-top: 35px;
      display: flex;
      justify-content: center;

      /deep/ .el-input {
        width: 95%;
        border: 0px;

        .el-input__inner {
          border-top: none !important;
          border-left: none !important;
          border-right: none !important;
          border-bottom: 1px solid #ccc !important;
          background-color: #EAF3FF;
          border-radius: 0px !important;
          //padding-left: 0px !important;
        }

        input::-webkit-input-placeholder {
          color: #353535;
        }
      }

      /deep/ .el-form-item__error {
        padding-left: 15px !important;
      }
    }
  }

  .boxinput1 {
    width: 1000px;
    height: 200px;
    background-color: #EAF3FF;

    .input-le1 {
      width: 1000px;
      padding-top: 50px;
      display: flex;
      justify-content: center;

      /deep/ .el-input {
        width: 95%;
        border: 0px;

        .el-input__inner {
          border-top: none !important;
          border-left: none !important;
          border-right: none !important;
          border-bottom: 1px solid #ccc !important;
          background-color: #EAF3FF;
          border-radius: 0px !important;
        }

        input::-webkit-input-placeholder {
          color: #353535;
        }
      }
    }

    .checkbox {
      width: 1000px;
      height: 90px;
      margin-top: 10px;

      .checkboxi {
        width: 95%;
        margin: 0 auto;
        display: flex;

        .box1 {
          width: 50%;
          height: 90px;
          text-align: left;


          p {
            padding-left: 10px;
            padding: 10px 13px 13px 100px;

            /deep/ .el-checkbox {
              .el-checkbox__label {
                color: #151414;
              }
            }
          }
        }

        .box2 {
          width: 50%;
          height: 90px;
          display: flex;
          flex-direction: column;
          justify-content: center;

          p {
            padding: 10px 13px 13px 130px;

            /deep/ .el-checkbox {
              .el-checkbox__label {
                color: #151414;
              }
            }
          }
        }
      }
    }

    .boxbutton {
      width: 100%;
      height: 90px;
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;

      .btnAdd {
        width: 100px;
        //height: 40px;
        //text-align: center;
        //margin: 0 auto;
      }
    }
  }
}

</style>
